//import liraries
import React, { useEffect, useState } from "react";
import { Dimensions } from "react-native";
import { CreateResponsiveStyle,DEVICE_SIZES, useDeviceSize,} from "rn-responsive-styles";


// define your styles
const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "100%",
      height: 450,
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginLeft: 20,
    },
    backIcon: {
      height: 19,
      width: 19,
      resizeMode: "center",
      opacity: 0.8,
    },
    subView: {
      flexDirection: "row",
      alignItems: "flex-start",
    },
    radiobuttonOutSideStyle: {
      width: 15,
      height: 15,
      borderRadius: 10,
      borderColor: "#9d1d27",
      borderWidth: 2,
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 10,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    radioButtonInsideStyle: {
      height: 7,
      width: 7,
      borderRadius: 7,
      backgroundColor: "#9d1d27",
    },
    bitMap: {
      width: 51.5,
      height: 47,
      borderRadius: 10,
      backgroundColor: "#ccd0d5",
      marginVerticle: 10,
    },
    textStyle: {
      color: "#999999",
      fontSize: 13,
      marginLeft: 10,
    },
    selectAllView: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    selectText: {
      fontSize: 15,
      fontWeight: "600",
      color: "#5f5f5f",
      width: 150,
      height: 25,
      marginLeft: 72,
      marginVertical: 15,
    },
    selectAll: {
      width: 120,
      height: 25,
      fontSize: 15,
      fontWeight: "600",
      color: "#bd2d37",
      marginVertical: 15,
    },
    imgContainer: {
      justifyContent: "space-evenly",
      flexDirection: "row",
      marginRight: 0,
    },
    firstContainer: {
      width: 300,
      marginLeft: 50,
    },
    emptyRadioBtn: {
      width: 18,
      height: 18,
      marginLeft: 10,
    },
    textStyle2: {
      height: 11,
      fontSize: 9,
      fontWeight: "600",
      color: "#02122c",
    },
    honda: {
      height: 11,
      fontSize: 9,
      fontWeight: "500",
      color: "#02122c",
    },
    number: {
      height: 15,
      fontSize: 13,
      fontWeight: "bold",
      color: "#bd2d37",
      marginLeft: 3,
      width: 50,
    },
    hondaTextContainer: {
      marginRight: 20,
      height: 30,
      alignItems: "flex-start",
      marginLeft: 10,
      marginTop: 10,
      width: 100,
    },
    numberContainer: {
      flexDirection: "row",
      alignItem: "flex-start",
      justifyContent: "center",
      marginVertical: 7,
      marginLeft: 40,
    },
    flatListView: {
      height: 200,
      paddingBottom: 20,
    },
    customButtonView: {
      width: 218,
      height: 37,
    },
    backIconView: {
      alignItems: "center",
      flexDirection: "row",
    },
    mobileCustomButtonStyle: {
      width: 218,
      height: 37,
      display: "none",
      alignSelf: "flex-end",
      marginBottom: 20,
    },
    viewStyle: {
      marginTop: 10,
      flexDirection: "row",
      paddingRight: 20,
      paddingHorizontal: 40,
      marginLeft: 5,
      justifyContent: "space-between",
      alignItems: "center",
    },
  },

  {
    [DEVICE_SIZES.SM]: {
      mainContainer: {
        width: "95%",
        height: 550.7,
        marginBottom: 50,
        paddingBottom: 50,
      },
      flatListView: {
        height: 600,
      },
      customButtonView: {
        display: "none",
      },
      firstContainer: {
        alignSelf: "flex-start",
        width: 260,
        marginLeft: 30,
      },
      backIconView: {
        alignSelf: "flex-start",
        marginLeft: 30,
        marginTop: 5,
      },
      imgContainer: {
        flexDirection: "column",
      },
      number: {
        fontSize: 13,
        fontWeight: "bold",
        color: "#bd2d37",
      },
      numberContainer: {
        flexDirection: "row",
        alignItem: "flex-start",
      },
      mobileCustomButtonStyle: {
        display: "flex",
      },
      viewStyle: {
        paddingHorizontal: 0,
        marginLeft: 0,
      },
      selectText: {
        marginLeft: 7,
        marginVertical: 15,
      },
    },

    [DEVICE_SIZES.MD]: {
      mainContainer: {
        flexDirection: "column",
        width: "100%",
        height: 550.7,
      },
      flatListView: {
        height: 600,
      },
      customButtonView: {
        display: "none",
      },
      backIconView: {
        marginTop: 5,
        alignSelf: "flex-start",
        marginLeft: 30,
      },
      firstContainer: {
        alignSelf: "flex-start",
        width: 270,
        marginLeft: 30,
      },
      imgContainer: {
        justifyContent: "space-between",
        flexDirection: "column",
      },
      number: {
        fontSize: 13,
        fontWeight: "bold",
        color: "#bd2d37",
      },
      numberContainer: {
        flexDirection: "row",
        alignItem: "flex-start",
      },
      mobileCustomButtonStyle: {
        display: "flex",
      },
      viewStyle: {
        paddingHorizontal: 0,
        marginLeft: 0,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainContainer: {
        width: "100%",
        height: 720.7,
        marginBottom: 50,
        paddingBottom: 50,
        marginLeft: 0,
      },
      flatListView: {
        width: "90%",
        height: "90%",
      },
      customButtonView: {
        display: "none",
      },
      firstContainer: {
        alignSelf: "flex-start",
        width: "90%",
        height: "60%",
        marginLeft: 0,
      },
      backIconView: {
        alignSelf: "flex-start",
        marginLeft: 30,
        marginTop: 5,
      },
      imgContainer: {
        flexDirection: "column",
        paddingHorizontal: 10,
      },
      number: {
        fontSize: 13,
        fontWeight: "bold",
        color: "#bd2d37",
      },
      numberContainer: {
        flexDirection: "row",
        alignItem: "flex-start",
      },
      mobileCustomButtonStyle: {
        display: "flex",
      },
      viewStyle: {
        paddingHorizontal: 0,
        marginLeft: 0,
      },
      selectText: {
        marginLeft: 25,
        marginVertical: 15,
      },
      hondaTextContainer: {
        width: 70,
        maxWidth: 70,
      },
    },
  }
);

//make this component available to the app
export default useStyles;
